import * as stylex from "@stylexjs/stylex";
import useLocale from "hooks/useLocale";
import { foldLocaleL } from "../../locales";
import { breakpoints, layoutAreas } from "../../materials/consts.stylex";
const TargetFourLogoImageSrc = foldLocaleL({
    ar: ()=>new URL("../../assets/bg_sdg-wheel_ar.svg", import.meta.url).href,
    de: ()=>new URL("../../assets/bg_sdg-wheel_de.svg", import.meta.url).href,
    en: ()=>new URL("../../assets/bg_sdg-wheel_en.svg", import.meta.url).href,
    es: ()=>new URL("../../assets/bg_sdg-wheel_es.svg", import.meta.url).href,
    fr: ()=>new URL("../../assets/bg_sdg-wheel_fr.svg", import.meta.url).href,
    ru: ()=>new URL("../../assets/bg_sdg-wheel_ru.svg", import.meta.url).href,
    zh: ()=>new URL("../../assets/bg_sdg-wheel_cn.svg", import.meta.url).href
});
export function TargetFourLogoBase({ locale }) {
    return <div className="x1lx81y2">
      <img alt="" src={TargetFourLogoImageSrc(locale)} className="x19bbpc0 x1mu601j x1t8ubdo"></img>
    </div>;
}
export function TargetFourLogo(props) {
    const locale = useLocale();
    return <TargetFourLogoBase locale={locale} {...props}/>;
}
